module.exports = "https://99designs-start-assets.imgix.net/js/2f4dbaa79771af3c6fa1c4310329996a.png";